export default {
  state: () => ({
    subscriptionToEdit: {},
    paymentRequestSchema: [],
    products: [],
    plans: [],
    mySubscriptions: [],
    activeSubscriptions: [],
    activeUserSubscriptions: [],
    myPayments: [],
    stripeKey: null
  })
}



// WEBPACK FOOTER //
// ./src/app/store/subscriptions/config.js